import React from 'react';
import { Container } from 'react-bootstrap';
import partner1 from '../../../assets/images/partner-1.webp';
import partner2 from '../../../assets/images/partner-2.webp';
import partner3 from '../../../assets/images/partner-3.webp';
import partner4 from '../../../assets/images/partner-4.webp';
import partner5 from '../../../assets/images/partner-5.webp';
import partner6 from '../../../assets/images/partner-6.webp';
import partner7 from '../../../assets/images/partner-7.webp';
import { ScrollText, Reveal, Stagger, StaggerItem } from '../../../components/motion';
import Eyebrow from '../../../components/ui/Eyebrow';
import styles from './CargoPartnersSection.module.css';

type Partner = {
  src: string;
  /** The name printed on the logo (checked against each image file). */
  name: string;
};

/** Saudia first — our home airline gets the wide tile. */
const PARTNERS: Partner[] = [
  { src: partner1, name: 'Saudia Cargo' },
  { src: partner2, name: 'Oman Air Cargo' },
  { src: partner3, name: 'Jazeera Air Cargo' },
  { src: partner4, name: 'Air India' },
  { src: partner5, name: 'Emirates SkyCargo' },
  { src: partner6, name: 'Garuda Indonesia' },
  { src: partner7, name: 'Aramex' },
];

const CargoPartnersSection: React.FC = () => {
  return (
    <section className={styles.partners}>
      <Container fluid="xl" className={styles.inner}>
        <div className={styles.grid}>
          <div className={styles.intro}>
            <Eyebrow className={styles.eyebrow}>Our cargo partners</Eyebrow>
            <ScrollText as="h2" className={styles.title}>
              Flown by airlines you know
            </ScrollText>
            <Reveal as="p" className={styles.body} delay={0.05}>
              We book space with leading airlines and carriers, so your cargo
              travels on scheduled flights from Saudi Arabia — tracked box by
              box until it reaches the door.
            </Reveal>
            <Reveal className={styles.stats} delay={0.1}>
              <div>
                <strong>{PARTNERS.length}</strong>
                <span>Partners</span>
              </div>
              <div>
                <strong>10</strong>
                <span>Countries</span>
              </div>
            </Reveal>
          </div>

          <Stagger as="ul" className={styles.logos} stagger={0.06} amount={0.15}>
            {PARTNERS.map((p) => (
              <StaggerItem key={p.name} as="li" direction="up" className={styles.tile}>
                <img src={p.src} alt={p.name} className={styles.logo} loading="lazy" />
                <span className={styles.name}>{p.name}</span>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </Container>
    </section>
  );
};

export default CargoPartnersSection;
